<script>
export default {
  name: 'Rating',
  props: {
    rating: { type: Number, default: 0 }
  }
}
</script>

<template>
  <span v-if="rating > 0" class="d-flex align-center">
    <v-rating
      v-model="rating"
      :length="1"
      :half-increments="true"
      :readonly="true"
      :size="15"
      :dense="true"
      color="#fbb03b"
      background-color="#fbb03b"
    />
    <span class="rating-label font-weight-medium ml-1">
      {{ (rating * 5) | round(1, true) }}
    </span>
  </span>
</template>

<style scoped lang="sass">

.rating-label
  color: #fbb03b
  font-size: 14px

.v-rating
  margin-top: -2px
  display: flex
</style>
